module.exports = __webpack_public_path__ + "img/baker.7e9fa22.png";